import React from 'react';

import { Chip } from '@infoods/lifebase-ui';

type AccountStatusChipProps = {
  isConnected: boolean;
};

const AccountStatusChip = ({ isConnected }: AccountStatusChipProps) => {
  if (isConnected) {
    return <Chip label="Contact is created" color="success" size="medium" />;
  } else {
    return <Chip label="Contact is not created" color="error" size="medium" />;
  }
};

export { AccountStatusChip };
